/** The board: six columns by six rows, 36 cells (the `merge` mechanic's rules). */
export const GRID_SIZE = { columns: 6, rows: 6 } as const;

export const GRID_CELL_COUNT = GRID_SIZE.columns * GRID_SIZE.rows;
